import { render, staticRenderFns } from "./bondValutionZhongzhai.vue?vue&type=template&id=60518be4&scoped=true&"
import script from "./bondValutionZhongzhai.vue?vue&type=script&lang=js&"
export * from "./bondValutionZhongzhai.vue?vue&type=script&lang=js&"
import style0 from "./bondValutionZhongzhai.vue?vue&type=style&index=0&id=60518be4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60518be4",
  null
  
)

export default component.exports